// src/components/layout/Header.jsx
import React from 'react';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const { user, selectedRole, logout } = useAuth();

  const getDisplayName = () => {
    if (user?.name) return user.name;
    if (user?.first_name && user?.last_name) return `${user.first_name} ${user.last_name}`;
    if (user?.first_name) return user.first_name;
    return user?.email || 'User';
  };

  const initial = getDisplayName().charAt(0).toUpperCase();

  return (
    <header className="bg-gray-100 border-b border-gray-200 px-6 py-2">
      <div className="flex items-center justify-between h-full">
        {/* Left side - Branding */}
          <div className="flex items-center space-x-3">
            <img
                src="/aimee-header-logo.svg"
                alt="Aimee Logo"
                className="h-10 w-auto"
              />
        </div>
        
        {/* Right side - User info and logout */}
        <div className="flex items-center space-x-4">
          {/* User Avatar */}
          <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
            <span className="text-sm font-medium text-blue-600">
              {initial}
            </span>
          </div>

          <div className="text-right">
            <p className="text-sm font-medium text-gray-900">
              {getDisplayName()}
            </p>
            <p className="text-xs text-gray-500 capitalize">
              {selectedRole}
            </p>
          </div>
          
          {/* Logout Button */}
          <button
            onClick={logout}
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;